/**
 * The three orthogonal anatomical planes a catstack can be sliced along.
 * Lives in the domain layer so View / ViewModel code can refer to the
 * type without importing from `@/api/*`.
 */
export const catstackPlaneIds = [
    'coronal',
    'axial',
    'sagittal',
] as const;

export type CatstackPlaneId = (typeof catstackPlaneIds)[number];
